import { useEffect } from "react";

const useUnityEventBindings = ({
  addEventListener,
  removeEventListener,
  onElementSelected,
  onElementDeselected,
  onEnvironmentChanged,
  onRecordingStarted,
  onUploadAudioFile,
  onReadyToLoadExperience,
  onSystemLoaded,
  onSystemFullyLoaded,
  onAssessmentComplete,
  onInstructionVisibilityChanged,
  onInsightStarted,
  onGameStateChanged,
}) => {
  useEffect(() => {
    addEventListener("elementSelected", onElementSelected);
    addEventListener("elementDeselected", onElementDeselected);
    addEventListener("environmentChanged", onEnvironmentChanged);
    addEventListener("recordingStarted", onRecordingStarted);
    addEventListener("uploadAudioFile", onUploadAudioFile);
    addEventListener("readyToLoadExperience", onReadyToLoadExperience);
    addEventListener("systemLoaded", onSystemLoaded);
    addEventListener("systemFullyLoaded", onSystemFullyLoaded);
    addEventListener("assessmentComplete", onAssessmentComplete);
    addEventListener(
      "instructionVisibilityChanged",
      onInstructionVisibilityChanged
    );
    addEventListener("insightStarted", onInsightStarted);
    addEventListener("gameStateChanged", onGameStateChanged);

    return () => {
      removeEventListener("elementSelected", onElementSelected);
      removeEventListener("elementDeselected", onElementDeselected);
      removeEventListener("environmentChanged", onEnvironmentChanged);
      removeEventListener("recordingStarted", onRecordingStarted);
      removeEventListener("uploadAudioFile", onUploadAudioFile);
      removeEventListener("readyToLoadExperience", onReadyToLoadExperience);
      removeEventListener("systemLoaded", onSystemLoaded);
      removeEventListener("systemFullyLoaded", onSystemFullyLoaded);
      removeEventListener("assessmentComplete", onAssessmentComplete);
      removeEventListener(
        "instructionVisibilityChanged",
        onInstructionVisibilityChanged
      );
      removeEventListener("insightStarted", onInsightStarted);
      removeEventListener("gameStateChanged", onGameStateChanged);
    };
  }, [
    addEventListener,
    removeEventListener,
    onElementSelected,
    onElementDeselected,
    onEnvironmentChanged,
    onRecordingStarted,
    onUploadAudioFile,
    onReadyToLoadExperience,
    onSystemLoaded,
    onSystemFullyLoaded,
    onAssessmentComplete,
    onInstructionVisibilityChanged,
    onInsightStarted,
    onGameStateChanged,
  ]);
};

export default useUnityEventBindings;
